import HelperDevelopment from "utils/helper-development";
import { configKeys } from "utils/config/keys";
import Constants from 'expo-constants';
import HelperVersion from 'utils/helper-version'
import _ from 'lodash'

export const apiConfigPrefixes = {
	PRODUCTION: '',
	TEST: 't_',
	DEVELOPMENT: 'd_'
};

export const apiConfigProduction = {
	[ configKeys.PREFIX ]: apiConfigPrefixes.PRODUCTION,
	[ configKeys.API_DOMAIN ]:  `https://server.werktopkantoor.nl/`,
	[ configKeys.API_DOMAIN_V2 ]:  `https://{{customer}}.server.werktopkantoor.nl/`,
	[ configKeys.API_GRAPHQL_ENDPOINT ]: 'connection/graphql',
	[ configKeys.CUSTOMER_ID ]: '',
};

export const apiConfigTest = {
	[ configKeys.PREFIX ]: apiConfigPrefixes.TEST,
	[ configKeys.API_DOMAIN ]:  `https://test-server.werktopkantoor.nl/`,
	[ configKeys.API_DOMAIN_V2 ]:  `https://test-server.werktopkantoor.nl/`,
	[ configKeys.API_GRAPHQL_ENDPOINT ]: 'connection/graphql',
	[ configKeys.CUSTOMER_ID ]: '',
};

export const apiConfigDevelopment = {
	[ configKeys.PREFIX ]: apiConfigPrefixes.DEVELOPMENT,
	[ configKeys.API_DOMAIN ]: `https://server.werktopkantoor.on-d-mand/`,
	[ configKeys.API_DOMAIN_V2 ]:  `https://server.werktopkantoor.on-d-mand/`,
	
	//[ configKeys.API_DOMAIN ]: `http://localhost:18000/`,
	//[ configKeys.API_DOMAIN_V2 ]:  `http://localhost:18000/`,
	
	//[ configKeys.API_DOMAIN ]: `https://e47b-95-99-161-130.ngrok-free.app/`,
	//[ configKeys.API_DOMAIN_V2 ]:  `https://e47b-95-99-161-130.ngrok-free.app/`,
	
	[ configKeys.API_GRAPHQL_ENDPOINT ]: 'connection/graphql',
	[ configKeys.CUSTOMER_ID ]: '',
}

let apiConfig = { ...apiConfigProduction };

// Test
if( _.includes( HelperVersion.getBuildVersion(), '-test' ) || _.includes(Constants.linkingUri ?? '', 'test-ota' ) || HelperDevelopment.isTestWeb() || HelperVersion.isTestVersion() ) {
	apiConfig = { ...apiConfigTest }
}

// Local
if( HelperDevelopment.isDev() ) {
	apiConfig = { ...apiConfigDevelopment }
}

export default apiConfig
